import React from 'react';
import { Box, Container, Typography, Chip, Stack } from '@mui/material';

const personas = [
  { label: 'QA Teams', icon: '🧪' },
  { label: 'Product Managers', icon: '📋' },
  { label: 'Engineering Leads', icon: '⚙️' },
  { label: 'Founders', icon: '🚀' },
  { label: 'SDETs', icon: '💻' },
  { label: 'DevOps', icon: '🔄' },
];

const AudienceStrip = () => {
  return (
    <Box sx={{ py: 6, borderTop: '1px solid rgba(0,0,0,0.05)', bgcolor: '#fafafa' }}>
      <Container maxWidth="xl">
        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          alignItems="center" 
          justifyContent="center" 
          spacing={4}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: '#64748b',
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              whiteSpace: 'nowrap',
            }}
          >
            Built for Modern Teams
          </Typography>
          
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
            {personas.map((persona, index) => (
              <Chip
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <span>{persona.icon}</span>
                    <span>{persona.label}</span>
                  </Box>
                }
                sx={{
                  bgcolor: 'white',
                  border: '1px solid #e2e8f0',
                  color: '#475569',
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  height: '40px',
                  px: 1,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    borderColor: '#667eea',
                    color: '#667eea',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                  }
                }}
              />
            ))}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default AudienceStrip;

